export const loadChatBot = (toHide?: boolean): void => {
  //Chat Bot
  const loadCrisp = () => {
    window.$crisp = [];
    // window.CRISP_WEBSITE_ID = "4f87b416-6723-4b45-a517-4ee62092d378";
    window.CRISP_WEBSITE_ID = '43f025bd-04e0-4021-9a1d-531309a357f5';

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  loadCrisp();
  
  // Apply custom classes to adjust chat widget position on smaller screens
  const responsiveStyle = document.createElement('style');
  responsiveStyle.innerHTML = `
    @media (max-width: 1024px) {
      .crisp-client .crisp-client {
        right: 0 !important;
        bottom: 0 !important;
        max-width: calc(100% - 20px) !important; /* Ensure it stays within the viewport */
        overflow: hidden !important;
      }
    }
  `;
  document.head.appendChild(responsiveStyle);

  // Handle visibility based on toHide parameter
  let visibilityStyle = document.getElementById('crisp-visibility-style') as HTMLStyleElement;
  if (!visibilityStyle) {
    visibilityStyle = document.createElement('style');
    visibilityStyle.id = 'crisp-visibility-style';
    document.head.appendChild(visibilityStyle);
  }

  if (!!toHide) {
    visibilityStyle.innerHTML = `
      #crisp-chatbox, [class*="crisp"], [id*="crisp"] {
        display: none !important;
        visibility: hidden !important;
      }
    `;
  } else {
    visibilityStyle.innerHTML = `
      #crisp-chatbox, [class*="crisp"], [id*="crisp"] {
        display: block !important;
        visibility: visible !important;
      }
    `;
  }
};

export const loadCookieEyes = () => {
  const script = document.createElement('script');
  script.src = 'https://cdn-cookieyes.com/client_data/29131085552c2dc4ec09d641/script.js';
  script.async = true;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const loadClarity = (clarityKey?: string): void => {
  if (!clarityKey) {
    return;
  }
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityKey}");
      `;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const loadGoogleTagManager = (gtmId: string): void => {
  if (!gtmId) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  // this logic was hidden because HotJar can't track page correctly when we use another iframes to track
  // const noscript = document.createElement('noscript');
  // noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
  //     height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  // document.body.appendChild(noscript);
};

export const loadGoogleApiPlaces = (apiKey: string): void => {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  script.async = true;
  script.onload = () => {
    if (window.google && window.google.maps) {
      // Google Maps API loaded successfully
      console.log('Google Maps API loaded');
    } else {
      console.error('Google Maps API failed to load');
    }
  };
  script.onerror = (error) => {
    console.error('Error loading Google Maps API script', error);
  };
  document.body.appendChild(script);
};

export const loadGoogleAnalytics = (gaId: string): void => {
  if (!gaId) return;

  const isDebug = process.env.REACT_APP_GA_DEBUG === 'true';
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}', { debug_mode: ${isDebug ? 'true' : 'false'} });
    `;
  document.head.appendChild(inlineScript);
};

export const loadIntroJS = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://cdnjs.cloudflare.com/ajax/libs/intro.js/8.3.2/intro.min.js`;
    script.async = true;
    script.onload = () => {
      if (window.introJs) {
        console.log('introJs loaded');
        resolve(window.introJs);
      } else {
        console.error('introJs failed to load');
        reject(new Error('introJs failed to load'));
      }
    };
    script.onerror = (error) => {
      console.error('Error loading introJs script', error);
    };
    document.body.appendChild(script);
  });
};
